import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import ReactSelect from 'react-select'

const styles = {
  groupStyles: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  groupBadgeStyles: {
    backgroundColor: '#FEE2E2',
    borderRadius: '2em',
    color: '#201030',
    display: 'inline-block',
    fontSize: 12,
    fontWeight: 'normal',
    lineHeight: '1',
    minWidth: 1,
    padding: '0.16666666666667em 0.5em',
    textAlign: 'center',
  },
  styles: {
    container: base => ({
      ...base,
      flex: 1,
      width: '100%',
    }),
    control: (provided, state) => ({
      ...provided,
      minHeight: 44,
      borderRadius: 12,
      borderColor: state.isFocused ? 'rgba(255, 21, 42, 0.45)' : '#E5E7EB',
      boxShadow: state.isFocused ? '0 0 0 3px rgba(255, 21, 42, 0.12)' : 'none',
      backgroundColor: '#fff',
      '&:hover': {
        borderColor: state.isFocused ? 'rgba(255, 21, 42, 0.45)' : '#D1D5DB',
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '0 1rem',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      paddingRight: 6,
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#9CA3AF',
    }),
  }
}

const Select = ({ classNameParent, text, size, icon, onChange, value, defaultValue, className, options, append, disabled, ...props }) => {
  const propValue = useCallback(() => {
    return defaultValue !== undefined && defaultValue !== null ? { defaultValue } : { value }
  }, [defaultValue, value])

  const hasAddon = !!(icon || (append && React.Children.count(append) > 0))

  return (
    <div className={classNameParent}>
      {text ? <label className="sp-field-label text-muted">{text}</label> : null}
      <div className={`sp-field-control input-group input-group-${size} ${hasAddon ? 'sp-field-control--addon' : ''}`.trim()}>
        {icon ? (
          <div className="input-group-prepend">
            <div className="input-group-text"><i className={icon}></i></div>
          </div>
        ) : null}
        <ReactSelect
          styles={styles.styles}
          options={options}
          {...propValue()}
          onChange={e => onChange(e)}
          formatGroupLabel={data => {
            return <div style={styles.groupStyles}>
              <span>{data.label}</span>
              <span style={styles.groupBadgeStyles}>{data.options.length}</span>
            </div>
          }}
          placeholder="Seleccionar..."
          className={className}
          {...props}
          isDisabled={disabled}
        />
        {append && React.Children.count(append) > 0 ? (
          <div className="input-group-append">
            {React.Children.toArray(append)}
          </div>
        ) : null}
      </div>
    </div>
  )
}

Select.defaultProps = {
  size: 'sm',
  icon: '',
  classNameParent: 'col-12',
  required: false,
  append: [],
  options: [],
  onChange: () => {},
  disabled: false
}
Select.propTypes = {
  classNameParent: PropTypes.string,
  text: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'lg']),
  icon: PropTypes.string,
  className: PropTypes.string,
  options: PropTypes.array,
  append: PropTypes.array,
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
  required: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool
}

export default Select
